import { setStoreValue } from "@/store/utils";

export const SET_IS_FETCHING_MESSAGE_TEMPLATES =
  "SET_IS_FETCHING_MESSAGE_TEMPLATES";
export const SET_MESSAGE_TEMPLATES = "SET_MESSAGE_TEMPLATES";
export const SET_IS_FETCHING_CURRENT_CONVERSATION =
  "SET_IS_FETCHING_CURRENT_CONVERSATION";
export const SET_CURRENT_CONVERSATION = "SET_CURRENT_CONVERSATION";

const mutations = {
  [SET_IS_FETCHING_MESSAGE_TEMPLATES]: setStoreValue(
    "isFetchingMessageTemplates"
  ),
  [SET_MESSAGE_TEMPLATES]: setStoreValue("messageTemplates"),
  [SET_CURRENT_CONVERSATION]: setStoreValue("currentConversation"),
  [SET_IS_FETCHING_CURRENT_CONVERSATION]: setStoreValue(
    "isFetchingCurrentConversation"
  )
};

const state = {
  messageTemplates: [],
  isFetchingMessageTemplates: false,
  currentConversation: null,
  isFetchingCurrentConversation: false
};

export { mutations, state };
